<panel>
  <h1>{{ 'task-area.list' | translate }}</h1>
  <list-view [emptyLabel]="'task-area.task-area-list-empty-label'">
    <header defaultSort="ascending">{{ 'general.name' | translate }}</header>
    <header></header>
    <row *listData="let taskArea from taskAreas" [highlighted]="activeTaskArea == taskArea" (action)="activeTaskArea = taskArea">
      <column>{{ taskArea.name }}</column>
      <column align-right><icon (click)="deleteTaskArea(taskArea)" type="trash-alt" /></column>
    </row>
  </list-view>
  <div (click)="createTaskArea()" class="button right confirm"> {{ 'task-area.create' | translate }}</div>
</panel>
@if (activeTaskArea) {
  <panel>
    <edit-task-area [taskArea]="activeTaskArea" (savedTaskArea)="updateTaskArea($event)" />
  </panel>
}
